import { EnvironmentEnum } from "node_modules/@synx-cloud/types";

export const environment = {
  production: true,
  environment: EnvironmentEnum.production
};
